import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { GenerateTermoColumns } from "./columns"
import { useTermoListaViewModel } from "../../viewModels/termo_lista_view_model"
import { Termo } from "../../../domain/models/termo"
import { CadastroTermoModal } from "./components/cadastro_termo_modal"



export const TermoLista = () => {
    const viewModel = useTermoListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateTermoColumns({
            onActionEdit: viewModel.handleTermoCadastroOpenState,
            onActionDelete: viewModel.handleDeleteOpenState,
        });
    }, [
        viewModel.handleTermoCadastroOpenState,
        viewModel.handleDeleteOpenState,
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewTermo()}>
                                    Novo Termo
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Termo
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Termo</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                codigo={viewModel.filters.codigo}
                                descricao={viewModel.filters.descricao}
                                nome={viewModel.filters.nome}
                                status={viewModel.filters.status}
                                handleCodigoChange={viewModel.handleCodigoChange}
                                handleDescricaoChange={viewModel.handleDescricaoChange}
                                handleNomeChange={viewModel.handleNomeChange}
                                onClearFilters={viewModel.handleClearFilters}
                                handleStatusChange={viewModel.handleStatusChange}
                            />


                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="Clientes_Lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: Termo) => row.idTermo}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.termoLista}
                                    rowCount={viewModel.termoLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idTermo'],
                                    }}
                                    getRowHeight={() => 'auto'}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }

            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarTermo}
            />

            <CadastroTermoModal
                open={viewModel.openCadastroModal}
                saving={viewModel.saving}
                loading={viewModel.loading}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                selectedTermo={viewModel.selectedTermo}
                onClose={() => viewModel.handleTermoCadastroOpenState(null, false)}
                onSubmit={viewModel.handleSubmitTermo}

            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

        </>
    )
}
